import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=6235ca9c&scoped=true"
import script from "./Commission.vue?vue&type=script&lang=js"
export * from "./Commission.vue?vue&type=script&lang=js"
import style0 from "./Commission.vue?vue&type=style&index=0&id=6235ca9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235ca9c",
  null
  
)

export default component.exports